import { authorizedRequest, authorizedRequestJson } from '../lib/authSession';

export function listTrips({ token }) {
  return authorizedRequestJson('/trips');
}

export function getTrip({ token, tripId }) {
  return authorizedRequestJson(`/trips/${encodeURIComponent(tripId)}`);
}

export function createTripPackage({ token, tripId, memberId }) {
  return authorizedRequestJson(`/trips/${encodeURIComponent(tripId)}/packages/${encodeURIComponent(memberId)}`, {
    method: 'POST',
  });
}

export async function deleteTripPackage({ token, tripId, memberId, packageId }) {
  const response = await authorizedRequest(
    `/trips/${encodeURIComponent(tripId)}/packages/${encodeURIComponent(memberId)}/${encodeURIComponent(packageId)}`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message ?? 'Request failed.');
  }
}

export function getTripPackageDownloadUrl({ token, tripId, memberId, packageId }) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/packages/${encodeURIComponent(memberId)}/${encodeURIComponent(packageId)}/download-url`,
    {
      method: 'POST',
    }
  );
}

export function deleteTrip({ token, tripId }) {
  return authorizedRequestJson(`/trips/${encodeURIComponent(tripId)}`, {
    method: 'DELETE',
  });
}

export function createTrip({ token, trip }) {
  return authorizedRequestJson('/trips', {
    method: 'POST',
    body: trip,
  });
}

export function attachTripRequirementDocument({ token, tripId, memberId, requirementUuid, documentId }) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/requirements/${encodeURIComponent(memberId)}/${encodeURIComponent(requirementUuid)}/documents`,
    {
      method: 'POST',
      body: { documentId },
    }
  );
}

export function removeTripRequirementDocument({ token, tripId, memberId, requirementUuid, documentId }) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/requirements/${encodeURIComponent(memberId)}/${encodeURIComponent(requirementUuid)}/documents/${encodeURIComponent(documentId)}`,
    {
      method: 'DELETE',
    }
  );
}

export function startTripRequirementAiValidation({ token, tripId, memberId, requirementUuid }) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/requirements/${encodeURIComponent(memberId)}/${encodeURIComponent(requirementUuid)}/validate-with-ai`,
    {
      method: 'POST',
    }
  );
}

export function listTripAiValidationTasks({ token, tripId }) {
  const query = tripId ? `?tripId=${encodeURIComponent(tripId)}` : '';
  return authorizedRequestJson(`/trips/ai-validation-tasks${query}`);
}

export async function deleteTripAiValidationTask({ token, taskId }) {
  const response = await authorizedRequest(
    `/trips/ai-validation-tasks/${encodeURIComponent(taskId)}`,
    {
      method: 'DELETE',
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.message ?? 'Request failed.');
  }
}

export function getTripRequirementTemplateDownloadUrl({ token, tripId, memberId, requirementUuid, templateKey }) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/requirements/${encodeURIComponent(memberId)}/${encodeURIComponent(requirementUuid)}/template-download-url?templateKey=${encodeURIComponent(templateKey)}`,
    {}
  );
}

export function fillTripRequirementTemplateWithAi({
  token,
  tripId,
  memberId,
  requirementUuid,
  templateId,
  memberIds,
}) {
  return authorizedRequestJson(
    `/trips/${encodeURIComponent(tripId)}/requirements/${encodeURIComponent(memberId)}/${encodeURIComponent(requirementUuid)}/fill-template-with-ai`,
    {
      method: 'POST',
      body: {
        templateId,
        memberIds,
      },
    }
  );
}
